// extracted by mini-css-extract-plugin
export default {"panel":"growth-submission-success_panel__V-1Ov","icon":"growth-submission-success_icon__k56ul","actions":"growth-submission-success_actions__aObsT"};